import { HelpMessage } from 'utils/constants'
import { ConcretePlacement } from '../../../types'
import SubTable from './SubTable'

const ThirdTable: React.FC<ConcretePlacement> = (record) => {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Placements
  return (
    <SubTable
      which="third"
      concretePlacement={record}
      columns={[
        {
          title: 'Contractor Name',
          help: help.ContractorName,
          width: 145,
          render: ({ contractor }) => contractor?.contractorName,
        },
        {
          title: 'Steel Notes',
          help: help.SteelNotes,
          width: 479,
          render: 'steelNotes',
        },
      ]}
    />
  )
}

export default ThirdTable
